export enum FitmentMasterNodeStatus {
    active = "8f1a2b3c-4d5e-4f6a-9b0c-1d2e3f4a5b6c",
    deleted = "9a2b3c4d-5e6f-4a7b-8c9d-0e1f2a3b4c5d",
}

export enum VariantCompatibilityLinkStatus {
    active = "a2b3c4d5-e6f7-4a8b-9c0d-1e2f3a4b5c6d",
    deleted = "b3c4d5e6-f7a8-4b9c-0d1e-2f3a4b5c6d7e",
}
